// // src/store/slices/myAttachmentSlice.js
// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import myAttachmentApi from 'api/attachmentApi'; // ← create this file

// export const fetchMyAttachments = createAsyncThunk(
//   'myAttachment/fetchMyAttachments',
//   async ({ page = 1, page_size = 10, search = '' }, { rejectWithValue }) => {
//     try {
//       const response = await myAttachmentApi.getMyAttachments({ page, page_size, search });
//       return response.data;  // ← already doing this
//     } catch (err) {
//       return rejectWithValue(err.response?.data?.detail || 'Failed to fetch attachments');
//     }
//   }
// );

// export const createMyAttachment = createAsyncThunk(
//   'myAttachment/createMyAttachment',
//   async (formData, { rejectWithValue }) => {
//     try {
//       const response = await myAttachmentApi.createMyAttachment(formData);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || 'Upload failed');
//     }
//   }
// );

// export const updateMyAttachment = createAsyncThunk(
//   'myAttachment/updateMyAttachment',
//   async ({ id, data }, { rejectWithValue }) => {
//     try {
//       const response = await myAttachmentApi.updateMyAttachment(id, data);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || 'Update failed');
//     }
//   }
// );

// export const deleteMyAttachment = createAsyncThunk(
//   'myAttachment/deleteMyAttachment',
//   async (id, { rejectWithValue }) => {
//     try {
//       await myAttachmentApi.deleteMyAttachment(id);
//       return id;
//     } catch (err) {
//       return rejectWithValue(err.response?.data?.detail || 'Delete failed');
//     }
//   }
// );

// // Export / Import thunks (if backend supports)
// export const exportMyAttachments = createAsyncThunk(
//   'myAttachment/exportMyAttachments',
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await myAttachmentApi.exportMyAttachments();
//       return response;
//     } catch (err) {
//       return rejectWithValue('Export failed');
//     }
//   }
// );

// export const importMyAttachmentsPreview = createAsyncThunk(
//   'myAttachment/importPreview',
//   async (file, { rejectWithValue }) => {
//     try {
//       const formData = new FormData();
//       formData.append('file', file);
//       const response = await myAttachmentApi.importPreview(formData);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || 'Preview failed');
//     }
//   }
// );

// export const importMyAttachmentsConfirm = createAsyncThunk(
//   'myAttachment/importConfirm',
//   async (previewData, { rejectWithValue }) => {
//     try {
//       const response = await myAttachmentApi.importConfirm(previewData);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || 'Import failed');
//     }
//   }
// );

// const myAttachmentSlice = createSlice({
//   name: 'myAttachment',
//   initialState: {
//     attachments: [],
//     pagination: { count: 0, current_page: 1, total_pages: 1, page_size: 10 },
//     isLoading: false,
//     error: null,
//   },
//   reducers: {
//     clearMyAttachmentError: (state) => {
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // fetch
//       .addCase(fetchMyAttachments.pending, (state) => { state.isLoading = true; })
//      .addCase(fetchMyAttachments.fulfilled, (state, action) => {
//   state.isLoading = false;
  
//   // Extract the actual array from response
//   const responseData = action.payload;
//   state.attachments = Array.isArray(responseData?.data) ? responseData.data : [];
  
//   // Pagination (your real structure has pagination object)
//   if (responseData?.pagination) {
//     state.pagination = responseData.pagination;
//   }
// })
//       .addCase(fetchMyAttachments.rejected, (state, action) => {
//         state.isLoading = false;
//         state.error = action.payload;
//       })

//       // create
//       .addCase(createMyAttachment.fulfilled, (state, action) => {
//         state.attachments.unshift(action.payload);
//         state.pagination.count += 1;
//       })

//       // update
//       .addCase(updateMyAttachment.fulfilled, (state, action) => {
//         const index = state.attachments.findIndex(a => a.id === action.payload.id);
//         if (index !== -1) state.attachments[index] = action.payload;
//       })

//       // delete
//       .addCase(deleteMyAttachment.fulfilled, (state, action) => {
//         state.attachments = state.attachments.filter(a => a.id !== action.payload);
//         state.pagination.count -= 1;
//       });
//   },
// });

// export const { clearMyAttachmentError } = myAttachmentSlice.actions;
// export default myAttachmentSlice.reducer;

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAttachmentApi from 'api/attachmentApi';

// ── Async Thunks ──────────────────────────────────────────────────────────

// export const fetchMyAttachments = createAsyncThunk(
//   'myAttachment/fetchMyAttachments',
//   async ({ page = 1, page_size = 10, search = '' }, { rejectWithValue }) => {
//     try {
//       const response = await myAttachmentApi.getMyAttachments({ page, page_size, search });
//       // Return the entire response.data object
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data?.detail || 'Failed to fetch attachments');
//     }
//   }
// );

// In your async thunk
export const fetchMyAttachments = createAsyncThunk(
  'myAttachment/fetchMyAttachments',
  async ({ page = 1, page_size = 10, search = '', employee = null }, { rejectWithValue }) => {
    try {
      const response = await myAttachmentApi.getMyAttachments({ 
        page, 
        page_size, 
        search, 
        employee 
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to fetch attachments');
    }
  }
);

export const fetchMyAttachmentById = createAsyncThunk(
  'myAttachment/fetchMyAttachmentById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await myAttachmentApi.getMyAttachmentById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to fetch attachment');
    }
  }
);

export const createMyAttachment = createAsyncThunk(
  'myAttachment/createMyAttachment',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await myAttachmentApi.createMyAttachment(formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Upload failed');
    }
  }
);

export const updateMyAttachment = createAsyncThunk(
  'myAttachment/updateMyAttachment',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await myAttachmentApi.updateMyAttachment(id, data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Update failed');
    }
  }
);

export const deleteMyAttachment = createAsyncThunk(
  'myAttachment/deleteMyAttachment',
  async (id, { rejectWithValue }) => {
    try {
      await myAttachmentApi.deleteMyAttachment(id);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Delete failed');
    }
  }
);

export const replaceAttachmentFile = createAsyncThunk(
  'myAttachment/replaceAttachmentFile',
  async ({ fileId, file }, { rejectWithValue }) => {
    try {
      const response = await myAttachmentApi.replaceAttachmentFile(fileId, file);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'File replace failed');
    }
  }
);

export const deleteAttachmentFile = createAsyncThunk(
  'myAttachment/deleteAttachmentFile',
  async (fileId, { rejectWithValue }) => {
    try {
      await myAttachmentApi.deleteAttachmentFile(fileId);
      return fileId;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'File delete failed');
    }
  }
);

export const exportMyAttachments = createAsyncThunk(
  'myAttachment/exportMyAttachments',
  async (_, { rejectWithValue }) => {
    try {
      const response = await myAttachmentApi.exportMyAttachments();
      return response;
    } catch (err) {
      return rejectWithValue('Export failed');
    }
  }
);

export const importMyAttachmentsPreview = createAsyncThunk(
  'myAttachment/importPreview',
  async (file, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await myAttachmentApi.importPreview(formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Preview failed');
    }
  }
);

export const importMyAttachmentsConfirm = createAsyncThunk(
  'myAttachment/importConfirm',
  async (previewData, { rejectWithValue }) => {
    try {
      const response = await myAttachmentApi.importConfirm(previewData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Import failed');
    }
  }
);

// ── Slice ─────────────────────────────────────────────────────────────────

const myAttachmentSlice = createSlice({
  name: 'myAttachment',
  initialState: {
    attachments: [],
    currentAttachment: null,
    pagination: {
      count: 0,
      current_page: 1,
      total_pages: 1,
      page_size: 10,
    },
    isLoading: false,
    isSubmitting: false,
    isDeleting: false,
    error: null,
    formErrors: {},
  },
  reducers: {
    clearMyAttachmentError: (state) => {
      state.error = null;
      state.formErrors = {};
    },
    setCurrentAttachment: (state, action) => {
      state.currentAttachment = action.payload;
    },
    setFormErrors: (state, action) => {
      state.formErrors = action.payload;
    },
    resetFormState: (state) => {
      state.isSubmitting = false;
      state.isDeleting = false;
      state.formErrors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      // ── Fetch All ────────────────────────────────────────────────────────
      .addCase(fetchMyAttachments.pending, (state) => { 
        state.isLoading = true; 
        state.error = null;
      })
      .addCase(fetchMyAttachments.fulfilled, (state, action) => {
        state.isLoading = false;
        
        // action.payload = { data: [...], pagination: {...} }
        const apiResponse = action.payload;
        
        // Extract attachments array
        state.attachments = Array.isArray(apiResponse?.data) ? apiResponse.data : [];
        
        // Extract pagination
        if (apiResponse?.pagination) {
          state.pagination = {
            count: apiResponse.pagination.count || 0,
            current_page: apiResponse.pagination.current_page || 1,
            total_pages: apiResponse.pagination.total_pages || 1,
            page_size: apiResponse.pagination.page_size || 10,
          };
        }
      })
      .addCase(fetchMyAttachments.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // ── Fetch Single ─────────────────────────────────────────────────────
      .addCase(fetchMyAttachmentById.pending, (state) => { state.isLoading = true; })
      .addCase(fetchMyAttachmentById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentAttachment = action.payload;
      })
      .addCase(fetchMyAttachmentById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })

      // ── Create ───────────────────────────────────────────────────────────
      .addCase(createMyAttachment.pending, (state) => { state.isSubmitting = true; })
      .addCase(createMyAttachment.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.attachments.unshift(action.payload);
        state.pagination.count += 1;
      })
      .addCase(createMyAttachment.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload;
        if (action.payload && typeof action.payload === 'object') {
          state.formErrors = action.payload;
        }
      })

      // ── Update ──────────────────────────────────────────────────────────
      .addCase(updateMyAttachment.pending, (state) => { state.isSubmitting = true; })
      .addCase(updateMyAttachment.fulfilled, (state, action) => {
        state.isSubmitting = false;
        const index = state.attachments.findIndex(a => a.id === action.payload.id);
        if (index !== -1) {
          state.attachments[index] = action.payload;
        }
        if (state.currentAttachment?.id === action.payload.id) {
          state.currentAttachment = action.payload;
        }
      })
      .addCase(updateMyAttachment.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload;
        if (action.payload && typeof action.payload === 'object') {
          state.formErrors = action.payload;
        }
      })

      // ── Delete Attachment ────────────────────────────────────────────────
      .addCase(deleteMyAttachment.pending, (state) => { state.isDeleting = true; })
      .addCase(deleteMyAttachment.fulfilled, (state, action) => {
        state.isDeleting = false;
        state.attachments = state.attachments.filter(a => a.id !== action.payload);
        state.pagination.count = Math.max(0, state.pagination.count - 1);
      })
      .addCase(deleteMyAttachment.rejected, (state, action) => {
        state.isDeleting = false;
        state.error = action.payload;
      })

      // ── Replace File ─────────────────────────────────────────────────────
      .addCase(replaceAttachmentFile.pending, (state) => { state.isSubmitting = true; })
      .addCase(replaceAttachmentFile.fulfilled, (state, action) => {
        state.isSubmitting = false;
        const index = state.attachments.findIndex(a => a.id === action.payload.id);
        if (index !== -1) {
          state.attachments[index] = action.payload;
        }
        if (state.currentAttachment?.id === action.payload.id) {
          state.currentAttachment = action.payload;
        }
      })
      .addCase(replaceAttachmentFile.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload;
      })

      // ── Delete File ──────────────────────────────────────────────────────
      .addCase(deleteAttachmentFile.pending, (state) => { state.isDeleting = true; })
      .addCase(deleteAttachmentFile.fulfilled, (state, action) => {
        state.isDeleting = false;
        if (state.currentAttachment) {
          state.currentAttachment.file_details = 
            (state.currentAttachment.file_details || []).filter(
              f => f.id !== action.payload
            );
        }
        const index = state.attachments.findIndex(a => a.id === state.currentAttachment?.id);
        if (index !== -1 && state.attachments[index].file_details) {
          state.attachments[index].file_details = 
            state.attachments[index].file_details.filter(f => f.id !== action.payload);
        }
      })
      .addCase(deleteAttachmentFile.rejected, (state, action) => {
        state.isDeleting = false;
        state.error = action.payload;
      });
  },
});

export const { 
  clearMyAttachmentError, 
  setCurrentAttachment, 
  setFormErrors, 
  resetFormState 
} = myAttachmentSlice.actions;

export default myAttachmentSlice.reducer;